import { __module as e } from "../../../_virtual/isBase64.js";
import { a as t } from "./util/assertString.js";
import { m as r } from "./util/merge.js";
!function (e, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = function (e, t) {
    (0, u.default)(e), t = (0, s.default)(t, l);
    var r = e.length;
    if (t.urlSafe) return o.test(e);
    if (r % 4 != 0 || i.test(e)) return !1;
    var a = e.indexOf("=");
    return -1 === a || a === r - 1 || a === r - 2 && "=" === e[r - 1];
  };
  var u = f(t),
    s = f(r);
  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var i = /[^A-Z0-9+\/=]/i,
    o = /^[A-Z0-9_\-]*$/i,
    l = {
      urlSafe: !1
    };
  e.exports = a.default, e.exports.default = a.default;
}(e, e.exports);
var a = e.exports;
export { a as i };